/* RL savings note — keeps the line under the CTA in step with the variant.

   The theme refreshes five nodes on a variant change (price, Sku, Inventory,
   Volume, Price-Per-Item); the savings line is none of them, and it was only
   rendered at all when the variant selected on load happened to be discounted.
   A product whose first variant is the cheapest — a tier picker, typically —
   therefore never showed it, whatever the customer picked afterwards.

   The line for every eligible variant is serialised server-side, so switching
   is a lookup rather than a fetch. The hook is the hidden id input: the theme
   writes the new variant into it and dispatches a bubbling change, on every
   path in and out of the picker, including the back button. */
(function () {
  'use strict';

  /* Strictly the product-info the input belongs to. No document fallback: a
     quick-add form elsewhere on the page carries its own input[name="id"], and
     a loose lookup would repaint the main note with that product's variant. */
  function scope(el) {
    return el.closest('product-info');
  }

  function readMap(root) {
    var script = root.querySelector('[data-rl-savings-map]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      // Loud on purpose. A malformed map fails the same way as a variant with
      // nothing to announce — the line simply stays hidden — and that silence
      // once cost a full deploy to notice an unquoted object key.
      console.warn('rl-savings-note: unreadable savings map', error);
      return null;
    }
  }

  function paint(root, variantId) {
    var note = root.querySelector('[data-rl-savings-note]');
    if (!note) return;
    var map = readMap(root);
    var text = map && variantId ? map[String(variantId)] : '';
    if (text) {
      note.textContent = text;
      note.hidden = false;
    } else {
      note.textContent = '';
      note.hidden = true;
    }
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.name !== 'id') return;
    var root = scope(target);
    if (!root) return;
    paint(root, target.value);
  });
})();
